import { render, staticRenderFns } from "./panelListing.vue?vue&type=template&id=4948c816&"
import script from "./panelListing.vue?vue&type=script&lang=js&"
export * from "./panelListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports